import { api } from '@/lib/api/client';
import type { TtsRow } from '../types';

/** Prompts uploaded in this editor session that no saved flow uses yet. */
const drafts = new Set<string>();

export function registerDraftPrompt(id: string | number) {
  drafts.add(String(id));
}

/** Flow saved: prompts present in the saved rows are no longer drafts. */
export function commitDraftPrompts(rows: TtsRow[]) {
  rows.forEach((r) => {
    if (r.ttsType === 'prompt') drafts.delete(String(r.value));
  });
}

/** Editor closed: delete every still-unsaved draft prompt (DB + audio file). */
export function discardDraftPrompts() {
  const ids = [...drafts];
  drafts.clear();
  ids.forEach((id) => {
    void api.delete(`/api/obd/tts-flow/draft-prompt/${id}`).catch(() => undefined);
  });
}